var e = {
	actions: {
		back: "Back",
		cancel: "Cancel",
		confirm: "Confirm",
		continue: "Continue",
		apply: "Apply",
		close: "Close",
		clear: "Clear",
		next: "Next",
		exit: "Exit",
		more: "More",
		save: "Save",
		delete: "Delete",
		remove: "Remove",
		edit: "Edit",
		add: "Add"
	},
	states: {
		error: "Error",
		somethingWentWrong: "Something went wrong.",
		pleaseTryAgain: "Please try again.",
		sharingUnavailable: "Sharing isn't available on this device."
	},
	noAccess: {
		title: "You don't have access",
		description: "Ask a workspace owner to grant you permission for this section.",
		goHome: "Go to Home"
	},
	rtlRestart: {
		title: "Restart required",
		message: "The app needs to restart to apply the new text direction.",
		restartNow: "Restart now",
		later: "Later"
	},
	appUpdate: {
		newVersionTitle: "A new version is available",
		newVersionDescription: "Reload to get the latest update.",
		requiredTitle: "A required update is available",
		requiredDescription: "Reload when you're ready to continue on the latest version.",
		reload: "Reload",
		downloading: "Updating Maat",
		almostReady: "Almost ready…"
	},
	translate: {
		translate: "Translate",
		showOriginal: "Show original",
		translating: "Translating…",
		autoTranslated: "Automatically translated",
		failed: "Translation is unavailable right now. Please try again later."
	},
	map: {
		getDirections: "Get directions",
		getDirectionsHint: "Opens directions to this place in your maps app"
	},
	ai: {
		title: "Maat AI",
		greeting: "Hi! I'm Maat, your travel assistant. Ask me anything about destinations!",
		inputPlaceholder: "Ask about a destination...",
		stopGenerating: "Stop generating",
		sendMessage: "Send message",
		copy: "Copy",
		copied: "Copied",
		thinking: "Maat is thinking",
		clearSelection: "Clear selection",
		pageContextLabel: "Asking about the listing you're viewing",
		pageContextDismiss: "Don't ask about this listing",
		pageContextTripLabel: "Asking about the trip you're viewing",
		pageContextTripDismiss: "Don't ask about this trip",
		openChat: "Open AI chat",
		closeChat: "Close AI chat",
		senderYou: "You",
		senderSystem: "System",
		feedback: {
			helpful: "Helpful",
			notHelpful: "Not helpful",
			modalTitle: "What went wrong?",
			commentLabel: "Tell us more (optional)",
			commentPlaceholder: "What was inaccurate or unhelpful about this response?",
			cancel: "Cancel",
			submit: "Submit feedback",
			failed: "Couldn't save your feedback. Please try again."
		},
		map: {
			away: "{{distance}} away",
			directions: "Directions",
			directionsTo: "Directions to {{place}}",
			drive: "Drive",
			walk: "Walk",
			driveTime: "drive",
			walkTime: "walk",
			byRoad: "by road"
		},
		followUps: {
			groupLabel: "Suggested next steps",
			checkAvailability: {
				label: "Is {{title}} free {{dates}}?",
				message: "Is {{title}} available {{dates}}?"
			},
			findSimilarForDates: {
				label: "Similar stays for {{dates}}",
				message: "Find similar stays in {{area}} for {{dates}}"
			},
			findLargerStays: {
				label: "Places that sleep {{count}}",
				message: "Find places in {{area}} that sleep {{count}}"
			},
			whatsNearby: {
				label: "What's nearby?",
				message: "What's near {{title}}?"
			},
			broadenSearch: {
				label: "More options in {{area}}",
				message: "Show me more options in {{area}}"
			},
			compareListings: {
				label: "Compare side by side",
				messageTwo: "Compare {{first}} and {{second}} for {{dates}}",
				messageThree: "Compare {{first}}, {{second}} and {{third}} for {{dates}}"
			},
			pickDates: {
				label: "Add your dates",
				changeLabel: "Try other dates",
				message: "We're travelling {{dates}}",
				dialogTitle: "When are you travelling?"
			},
			pickGuests: {
				label: "How many guests?",
				message_one: "It's just me",
				message_other: "We're {{count}} guests",
				dialogTitle: "Who's coming?",
				count_one: "{{count}} guest",
				count_other: "{{count}} guests",
				decrease: "Fewer guests",
				increase: "More guests"
			},
			openCheckout: {
				label: "Book {{dates}} · {{total}}",
				estimatedLabel: "Book {{dates}} · about {{total}}"
			},
			apply: "Done",
			cancel: "Cancel"
		},
		comparison: {
			title: "Side by side",
			stayRow_one: "{{dates}} · {{count}} guest",
			stayRow_other: "{{dates}} · {{count}} guests",
			estimatedTotal: "about {{total}}",
			taken: "Taken",
			notBookable: "Not bookable",
			sleeps: "Sleeps",
			tooSmall: "{{count}} · too small",
			bedrooms: "Bedrooms",
			bathrooms: "Bathrooms",
			rating: "Rating",
			ratingValue: "{{rating}} ({{count}})",
			noReviews: "No reviews yet",
			instantBook: "Instant book",
			yes: "Yes",
			no: "No",
			book: "Book",
			view: "View"
		},
		listingFacts: {
			title: "About this place",
			viewListing: "View listing",
			houseRules: "House rules",
			notSpecified: "Not specified",
			times: "Check-in and check-out",
			cancellation: "Cancellation",
			policy: "{{policy}} policy",
			refundFull: "Full refund",
			refundNone: "No refund",
			refundPartial: "{{percent}}% refund",
			refundBy: "{{refund}} if you cancel by {{date}}",
			refundDaysBefore_one: "{{refund}} up to {{count}} day before check-in",
			refundDaysBefore_other: "{{refund}} up to {{count}} days before check-in",
			refundHoursBefore_one: "{{refund}} up to {{count}} hour before check-in",
			refundHoursBefore_other: "{{refund}} up to {{count}} hours before check-in",
			refundOtherwise: "{{refund}} after that",
			reviews: "What guests say",
			ratingLine_one: "{{rating}} · {{count}} review",
			ratingLine_other: "{{rating}} · {{count}} reviews",
			noReviews: "No reviews yet",
			mentions_one: "{{count}} mention",
			mentions_other: "{{count}} mentions",
			quoteBy: "— {{name}}",
			amenities: "Amenities",
			listed: "Listed",
			notListed: "Not on the listing",
			space: "The space",
			sleeps_one: "Sleeps {{count}}",
			sleeps_other: "Sleeps {{count}}",
			bedrooms_one: "{{count}} bedroom",
			bedrooms_other: "{{count}} bedrooms",
			beds_one: "{{count}} bed",
			beds_other: "{{count}} beds",
			bathrooms_one: "{{count}} bathroom",
			bathrooms_other: "{{count}} bathrooms",
			askHint: "The listing doesn't say — the host can tell you.",
			askHost: "Ask the host",
			draftIntro: "Hi! A few questions about {{title}}:",
			draftAsk: "{{label}}?",
			openError: "Couldn't open the conversation. Please try again."
		},
		guestTrips: {
			viewBooking: "View booking",
			leaveReview: "Leave a review",
			seeAllTrips: "See all trips",
			untitled: "Your trip",
			nights_one: "{{count}} night",
			nights_other: "{{count}} nights",
			chip: {
				today: "Today",
				tomorrow: "Tomorrow",
				inDays_one: "In {{count}} day",
				inDays_other: "In {{count}} days",
				inWeeks_one: "In {{count}} week",
				inWeeks_other: "In {{count}} weeks",
				inMonths_one: "In {{count}} month",
				inMonths_other: "In {{count}} months",
				stayingNow: "Staying now",
				endedToday: "Ended today",
				endedDays_one: "Ended {{count}} day ago",
				endedDays_other: "Ended {{count}} days ago",
				endedWeeks_one: "Ended {{count}} week ago",
				endedWeeks_other: "Ended {{count}} weeks ago",
				endedMonths_one: "Ended {{count}} month ago",
				endedMonths_other: "Ended {{count}} months ago"
			},
			refund: {
				withdrawFull: "Full refund if you withdraw now",
				fullNow: "Full refund if you cancel now",
				noneNow: "No refund if you cancel now",
				fullUntil: "Full refund until {{date}}",
				partialUntil: "{{percent}}% back until {{date}}",
				partialNow: "{{percent}}% back if you cancel now"
			}
		},
		totalBookings: "Total bookings",
		gmv: "GMV",
		hostPayout: "Host payout",
		bookingsByStatus: "Bookings by status",
		revenueLastMonths: "Revenue · last {{months}} months ({{currency}})",
		bookingsPerMonth: "Bookings per month",
		bookings: "Bookings",
		averageRating: "Average rating",
		reviewCount_one: "{{count}} review",
		reviewCount_other: "{{count}} reviews",
		guests_one: "{{count}} guest",
		guests_other: "{{count}} guests",
		adminTitle: "Maat Ops",
		adminGreeting: "Ask me about platform performance, bookings, finances or AI spend.",
		adminInputPlaceholder: "Ask about the platform...",
		adminSuggestionSummary: "How is the platform doing?",
		adminSuggestionTrends: "Show revenue trends for the last 6 months",
		adminSuggestionCancellations: "Cancellations this month",
		adminSuggestionFinance: "What do we owe hosts right now?",
		totalUsers: "Users",
		totalWorkspaces: "Workspaces",
		totalListings: "Listings",
		pendingVerifications: "Pending verifications",
		openSupportTickets: "Open tickets",
		activeAdmins: "Active admins",
		escrowTotal: "In escrow",
		availableTotal: "Available",
		payoutPendingTotal: "Reserved for payouts",
		pendingPayouts: "Payout requests",
		paidOutTotal: "Paid out",
		outstandingDebt: "Outstanding host debt",
		couponDeficit: "Coupon deficit",
		hostFundsByState: "Host funds by state",
		totalGenerations: "Generations",
		totalCost: "AI spend",
		upRate: "Thumbs-up rate",
		chatFeedback: "Chat ratings",
		chatPositiveRate: "Chat positive rate",
		thumbsDown: "Thumbs down",
		generationsByIntent: "Generations by intent",
		generations: "Generations",
		ratedCount_one: "{{count}} rated",
		ratedCount_other: "{{count}} rated",
		feedbackWindow_one: "last {{count}} day",
		feedbackWindow_other: "last {{count}} days",
		notRated: "Not rated",
		unknown: "Unknown",
		viewDashboard: "View dashboard",
		viewFinance: "View finance",
		viewGenerations: "View AI audit",
		rating: {
			prompt: "Was this helpful?",
			thumbsUp: "Good result",
			thumbsDown: "Poor result",
			thanks: "Thanks for the feedback!"
		}
	},
	errors: {
		description: "An unexpected error occurred. Our team has been notified.",
		retry: "Try again",
		reload: "Reload",
		details: "Error details",
		connection: "Something went wrong.\nCheck your connection and try again.",
		loadFailed: {
			title: "We're having trouble connecting",
			description: "Part of the app didn't load. Check your connection and try again."
		}
	},
	marketing: { dismiss: "Dismiss" },
	markdown: {
		placeholder: "Write markdown…",
		write: "Write",
		preview: "Preview",
		nothingToPreview: "_Nothing to preview yet._",
		toolbar: {
			bold: "Bold",
			italic: "Italic",
			heading: "Heading",
			bulletList: "Bulleted list",
			numberedList: "Numbered list",
			quote: "Quote",
			code: "Inline code",
			link: "Link"
		},
		placeholders: {
			bold: "bold text",
			italic: "italic text",
			code: "code",
			link: "link text"
		},
		chips: { hint: "Fields — drag into the text, or click to insert at the cursor" }
	},
	motion: {
		demoControls: "Demo controls",
		previousStep: "Previous step",
		nextStep: "Next step",
		pause: "Pause",
		play: "Play",
		goToStep: "Go to step {{step}}"
	},
	pullToRefresh: {
		messages: {
			shared: {
				goodVibes: "Some good vibes.",
				alreadyFresh: "That's as fresh as it gets.",
				checkedTwice: "Checked. Twice now, actually.",
				nothingUpHere: "Nothing to see up here.",
				niceToSeeYou: "Nothing new — nice to see you though.",
				takeABreath: "Take a breath. We just did."
			},
			guest: {
				noHiddenFees: "No hidden fees here either.",
				nextStay: "Your next stay is down there.",
				sheetsClean: "The sheets are already clean.",
				samePrices: "Still the same price you saw."
			},
			host: {
				calendarSteady: "Your calendar hasn't moved since you asked.",
				noNewBookings: "No new bookings in the last few seconds.",
				payoutsPace: "Payouts don't move quite that fast.",
				listingsPut: "Your listings are exactly where you left them.",
				alreadyCounted: "Everything's already counted."
			}
		},
		coupon: "You're holding {{discount}} off. Use {{code}} at checkout."
	},
	pdf: {
		payout: {
			title: "Payout statement",
			statementNumber: "Statement {{number}}",
			issued: "Issued {{date}}",
			onItsWay: "On its way",
			paidOn: "Paid · {{date}}",
			paidTo: "Paid to",
			taxId: "Tax ID {{value}}",
			registrationNumber: "Commercial registration {{value}}",
			payoutMethod: "Payout method",
			transferReference: "Transfer reference",
			requested: "Requested",
			summary: "Payout summary",
			reservations_one: "{{count}} reservation",
			reservations_other: "{{count}} reservations",
			totalPayout: "Total payout ({{currency}})",
			totalPaid: "Total paid ({{currency}})",
			transfer: "Transfer",
			transferPending: "Maat sends payouts by hand. The transfer details appear here once it's sent.",
			sent: "Sent {{date}}",
			reference: "ref {{value}}",
			receiptOnFile: "Bank transfer receipt on file",
			reservationsTitle: "Reservations in this payout",
			listing: "Listing",
			fallbackListing: "Reservation",
			stay: "Stay",
			amount: "Amount",
			noLineAmounts: "Per-reservation amounts weren't recorded for this payout. The total above is the full amount.",
			method: {
				bankTransfer: "Bank transfer •••• {{last4}}",
				bankTransferNoDigits: "Bank transfer",
				instapay: "InstaPay •••• {{last4}}",
				instapayNoDigits: "InstaPay",
				wallet: "Mobile wallet •••• {{last4}}",
				walletNoDigits: "Mobile wallet",
				other: "Payout account"
			},
			verifyTitle: "This payout in Maat",
			verifyHint: "Scan the code, or open the link while signed in, to see this payout.",
			help: "Questions about this payout? Message Maat support from your dashboard."
		},
		invoice: {
			title: "Your receipt from Maat",
			receiptNumber: "Receipt {{number}}",
			issued: "Issued {{date}}",
			nights_one: "{{count}} night",
			nights_other: "{{count}} nights",
			guests_one: "{{count}} guest",
			guests_other: "{{count}} guests",
			checkIn: "Check-in",
			checkOut: "Checkout",
			checkInFrom: "From {{time}}",
			checkOutBy: "By {{time}}",
			date: "Date",
			time: "Time",
			confirmationCode: "Confirmation code",
			billedTo: "Billed to",
			cancellationPolicy: "Cancellation policy",
			address: "Address",
			priceBreakdown: "Price breakdown",
			total: "Total ({{currency}})",
			payment: "Payment",
			amountPaid: "Amount paid ({{currency}})",
			line: {
				nights_one: "{{rate}} × {{count}} night",
				nights_other: "{{rate}} × {{count}} nights",
				seats_one: "{{count}} seat",
				seats_other: "{{count}} seats",
				cleaning: "Cleaning fee",
				fees: "Additional fees",
				service: "Maat service fee",
				cancellationCover: "Flexible cancellation",
				coupon: "Coupon {{code}}",
				couponNoCode: "Coupon",
				adjustment: "Changes to your reservation"
			},
			method: {
				card: "{{brand}} •••• {{last4}}",
				cardNoDigits: "{{brand}} card",
				cardUnknown: "Card",
				applePay: "Apple Pay · {{card}}",
				applePayAlone: "Apple Pay",
				googlePay: "Google Pay · {{card}}",
				googlePayAlone: "Google Pay",
				wallet: "Mobile wallet •••• {{last4}}",
				walletNoDigits: "Mobile wallet",
				other: "Paid online"
			},
			verifyTitle: "This booking in Maat",
			verifyHint: "Scan the code, or open the link while signed in, to see this reservation.",
			help: "Questions about this receipt? Message Maat support from your trip."
		}
	},
	notFound: {
		pageTitle: "Page not found",
		title: "This page doesn't exist",
		description: "The link may be out of date, or the address may have a typo.",
		goHome: "Go to home",
		exploreStays: "Explore stays",
		goToDashboard: "Go to dashboard"
	},
	pricing: {
		perPerson: "per person",
		perGroup: "per group",
		perNight: "per night"
	},
	units: {
		minutes: "min",
		days: "days",
		kilometres: "km"
	},
	boot: {
		loading: "Loading Maat Stays",
		tagline: "Stays worth the trip",
		lines: {
			message: "Message your host before you book",
			pay: "Pay in EGP or USD",
			favourites: "Save the places you love for later"
		},
		slow: "Still loading. Slow connections can take a moment.",
		failed: "We're having trouble connecting.",
		retry: "Try again"
	}
};
//#endregion
export { e as default };
